// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"453":"43a5fe21","586":"06bab1a7","790":"37b85fd2"}[chunkId] + ".chunk.js";
};